import React from "react";



const Strike = ({ strikeClass }) => {
    return (
        <>
            <div className={`strike ${strikeClass}`}></div>
        </>
    )
}



export default Strike;
